const SearchOverlay = {

  _selectors: {
    overlay: '.js-search-overlay',
    triggerBtn: '.js-search-overlay-trigger-btn',
    closeBtn: '.js-search-overlay-close-btn',
    searchForm: '.js-search-form'
  },

  _isOpen: false,

  init() {
    // Event :: button click that opens overlay
    document.querySelector(this._selectors.triggerBtn).addEventListener('click', this.show.bind(this));

    // Event :: button click that closes overlay
    document.querySelector(this._selectors.closeBtn).addEventListener('click', this.hide.bind(this));

    // TODO - do this after making sure nothing gets returned in PHP
    // Event :: prevents empty search submissions
    // document.querySelector(this._selectors.searchForm).addEventListener('submit', evt => {
    //   evt.preventDefault();
    // });
  },

  show() {
    if ( this._isOpen ) {
      return;
    }

    document.querySelector('body').classList.add('no-scroll');
    document.querySelector(this._selectors.overlay).classList.add('show');

    this._isOpen = true;
  },

  hide() {
    if ( ! this._isOpen ) {
      return;
    }

    document.querySelector('body').classList.remove('no-scroll');
    document.querySelector(this._selectors.overlay).classList.remove('show');

    this._isOpen = false;
  }
};

export default SearchOverlay;
